import React, { useState, useEffect, lazy, Suspense } from "react";
import "./partner.css";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { MainContent } from "../../layouts/MainContent";
import { Headers } from "../../layouts/headers/headers";
import PartnerFilter from "../../components/filters/filterPartner";
import { PartnerList } from "../../components/datatable/PartnerList";
import { getPartners } from "../../interpreter/partner";
import { useAuth } from "../../contexts/authContexts";

const UserModal = lazy(() => import("../../components/modals/profileUser"));
const ResetPasswordModal = lazy(() => import("../../components/modals/resetPassword"));
const CreatePartnerModal = lazy(() => import("../../components/modals/createPartner"));
const BulkUploadPartnerModal = lazy(() => import("../../components/modals/bulkUploadPartner"));
const PermissionDeniedModal = lazy(() => import("../../components/modals/denegPermisse"));

const Partner = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  const { user } = useAuth();
  const tienePermiso = user?.permissions?.some((p) => p.name === "manage-partners");

  useEffect(() => {
    if (!tienePermiso) setShowPermissionModal(true);
  }, [tienePermiso]);

  const fetchPartners = async () => {
    try {
      const data = await getPartners(null);
      setPartners(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error al obtener partners:", error);
      setPartners([]);
    }
  };

  useEffect(() => {
    if (tienePermiso) fetchPartners();
  }, [tienePermiso]);

  const openModal = (modalType, partner) => {
    setSelectedPartner(partner);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedPartner(null);
  };

  const handleSuccess = () => {
    fetchPartners();
    closeModal();
  };

  const closePermissionModal = () => {
    setShowPermissionModal(false);
    window.history.back();
  };

  const resetUserAdapter = selectedPartner
    ? {
        id_technician: selectedPartner.id,
        full_name: `${selectedPartner.firstName || ""} ${selectedPartner.lastName || ""}`.trim(),
      }
    : null;

  return (
    <div className="flex h-screen">
      <Headers />

      <MainContent>
        <HeadersCentral showDropdown={showDropdown} setShowDropdown={setShowDropdown} openModal={() => openModal("user")} />

        <main className="p-6">
          <h1 className="text-3xl font-bold mb-6 flex items-center gap-3 text-gray-800">
            <svg className="w-8 h-8 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2a8 8 0 00-8 8v4a2 2 0 002 2h2l1 2h6l1-2h2a2 2 0 002-2v-4a8 8 0 00-8-8z" />
            </svg>
            Panel de Técnicos Partner
          </h1>

          <div className="flex flex-wrap gap-3 mb-4">
            <button
              onClick={() => openModal("create")}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow"
            >
              <span>+</span> Registro manual
            </button>
            <button
              onClick={() => openModal("bulk")}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow"
            >
              <span>📤</span> Carga masiva Excel
            </button>
          </div>

          <PartnerFilter setPartners={setPartners} />
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <PartnerList partners={partners} openModal={openModal} onRefresh={fetchPartners} />
          </div>
        </main>
      </MainContent>
      <Suspense fallback={null}>
        {showPermissionModal && (
          <PermissionDeniedModal isOpen={showPermissionModal} onClose={closePermissionModal} />
        )}
        {activeModal === "user" && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === "reset" && resetUserAdapter && (
          <ResetPasswordModal
            isOpen={true}
            onClose={closeModal}
            user={resetUserAdapter}
            userType="Tecnico"
          />
        )}
        {activeModal === "create" && (
          <CreatePartnerModal isOpen={true} onClose={closeModal} onSuccess={handleSuccess} />
        )}
        {activeModal === "bulk" && (
          <BulkUploadPartnerModal isOpen={true} onClose={closeModal} onSuccess={handleSuccess} />
        )}
      </Suspense>
    </div>
  );
};

export default Partner;
